import React, { FC, useMemo } from 'react';
import { useTenderData } from 'src/models/procurements/Tender/hooks';
import { TenderSubCatName, TenderBoxMode, TenderBlockSize } from 'src/models/procurements/Tender/types';
import { TenderBox, TenderSubCat } from 'src/shared';

export const AdditionalSubCat: FC = () => {
  const { data } = useTenderData();
  const subCat = useMemo(() => data?.generalCat[TenderSubCatName.Additional], [data]);
  const boxes = useMemo(() => subCat?.boxes, [subCat]);
  const editable = !!data?.isEditable;

  return (
    <>
      {!!subCat && boxes && !!boxes.length && (
        <TenderSubCat subCat={subCat} boxTheme={false}>
          {boxes.map(box =>
            Array.isArray(box) && !!box.length ? (
              <TenderBox
                boxes={box}
                as={TenderBoxMode.Collection}
                title={box[0].title}
                key={box[0].id}
                size={TenderBlockSize.ThreeQuarters}
                boxMode={editable}
                isEditable={editable}
                config={{ isTitle: true }}
                hideEmpty={true}
              />
            ) : (
              !Array.isArray(box) && (
                <TenderBox
                  box={box}
                  as={TenderBoxMode.Base}
                  key={box.id}
                  size={TenderBlockSize.ThreeQuarters}
                  boxMode={editable}
                  isEditable={editable}
                  hideEmpty={true}
                />
              )
            )
          )}
        </TenderSubCat>
      )}
    </>
  );
};

export default AdditionalSubCat;
